import { render, staticRenderFns } from "./TestComponent.vue?vue&type=template&id=1efd4d0a&scoped=true&"
import script from "./TestComponent.vue?vue&type=script&lang=ts&"
export * from "./TestComponent.vue?vue&type=script&lang=ts&"
import style0 from "./TestComponent.vue?vue&type=style&index=0&id=1efd4d0a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1efd4d0a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!D:/project/xunjie/ams_old/ams-admin/node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VForm } from 'vuetify/lib'
import { VIcon } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {VBtn,VForm,VIcon,VTextField})
